<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyTabLinks />
                    <div class="py-3 px-3">
                        Средняя оценка по опросу: <b>{{ averageEstimation}}</b>
                    </div>
                    <CRow>
                        <CCol>
                            <table class="table">
                                <thead>
                                    <th>Дата</th>
                                    <th>Пользователь</th>
                                </thead>
                                <tbody>
                                    <template v-for="item in results">
                                        <tr :key="item.id" v-if="item.customer_id">
                                            <td class="p-1">
                                                {{ formatDate(item.created_at) }}
                                            </td>
                                            <td class="p-1">
                                                <CLink
                                                    :to="`/surveys/${entity.id}/results/${item.customer_id}`"
                                                >{{ item.customer.phone }}</CLink>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="save"
                    >Сохранить расположение</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';
    import SurveyTabLinks from '@/components/surveys/SurveyTabLinks';
    const { formatDate } = require('@/utils/views');

    export default {
        name: 'RestaurantDishes',

        components: {
            SurveyTabLinks,
            draggable,
        },

        data() {
            return {
                formatDate,
                entity: {},
                results: [],
                averageEstimation: 0
            };
        },
        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            }
        },
        async mounted() {
            const id = this.$route.params.id;
            try {
                const { data } = await Vue.axios.get(`/surveys/${id}`);
                this.entity = data;
                this.results = data.results;
                const { data: averageEstimation } = await Vue.axios.get(`/surveys/${id}/results/average-estimation`);
                this.averageEstimation = averageEstimation;
            }
            catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки данных.');   
            }
        },

        icons: {
            cilCursorMove,
        },

        methods: {
            save() {
                const reorder = [];
                let index = 0;
                this.questions.forEach(item => {
                    reorder.push({
                        id: item.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/surveys/' + this.entity.id + '/questions/reorder', { reorder: reorder })
                    .then(() => {
                        this.$router.push('/surveys/' + this.entity.id);
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            update(item) {
                Vue.axios.put('/surveys/' + this.entity.id + '/questions/' + item.id, item)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            create() {
                this.$router.push(
                    '/surveys/' + this.entity.id + '/questions/create'
                );
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        },
    };
</script>
<style lang="scss" scoped>
.table {
    tr {
        td {
            padding: 0 .2rem;

            &:nth-child(2) {
                max-width: 30vw;
            }
        }
    }
}
</style>
